module.exports = __webpack_public_path__ + "img/landscape.6ef75344.jpg";